import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { RateType } from 'anchor-shared/lib/model/enum/vessel-rate-types';

@Component({
  selector: 'edit-button',
  styleUrls: ['./customPrice.component.scss'],
  templateUrl: './customPrice.component.html',
})
export class CustomPriceComponent implements AgRendererComponent {
  manageButton: boolean;

  refresh(params: any): boolean {
    return undefined;
  }
  public params: any;
  public isCustom: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.isCustom = [RateType.Custom, RateType.Cleaning].includes(
      params.data.rateType,
    );
  }

  public invokeDelete() {
    this.params.context.componentParent.deleteRate(this.params);
  }
}
